<template>
    <div class="flex flex-col justify-center items-center mb-20 mt-40">
        <h2 v-if="page === 'ecommerce'" class="font-trap sm:text-40 leading-12 text-center text-28 mb-3 md:mb-6">
            Key
            Features of a Custom eCommerce Solution</h2>
        <h2 v-else-if="page === 'food-delivery'"
            class="font-trap sm:text-40 text-center max-sm:leading-8 text-28 mb-3 md:mb-6">
            Key Features of a Food Delivery App Solution
        </h2>
                <h2 v-else-if="page === 'elearning'"
            class="font-trap sm:text-40 text-center max-sm:leading-8 text-28 mb-3 md:mb-6">
            Key Features of an Elearning Software Solutions
        </h2>
        <h2 v-else class="font-trap sm:text-40 text-center max-sm:leading-8 text-28 mb-3 md:mb-6">Key Features Of
            Healthcare
            Apps</h2>
        <p v-if="page === 'ecommerce'"
            class="text-grayText text-center w-full leading-7 lg:w-4/5 mb-6 md:mb-8 text-sm md:text-[16px] font-medium">
            The features of your e-retail solution can make or break the success of your eCommerce business. When
            designing eCommerce development solutions, our experts determine which functionalities boost your brand's
            recognition and increase conversions.
        </p>
        <p v-else-if="page === 'food-delivery'"
            class="text-grayText text-center w-full leading-7 lg:w-4/5 mb-6 md:mb-8 text-sm md:text-[16px] font-medium">
            It is critical to determine the appropriate feature set for on demand food delivery software to enable you
            to outperform competitors. We have a carefully selected set of features to help your food delivery app stand
            out. This is a list of the fundamental features:
        </p>
        <p v-else-if="page === 'elearning'"
            class="text-grayText text-center w-full leading-7 lg:w-4/5 mb-6 md:mb-8 text-sm md:text-[16px] font-medium">
            It is important to determine the best feature list for your app. Features help you stand above your competition. 
            The list of basic features includes those recommended by leading eLearning experts, ensuring your app meets industry standards and user expectations.
        </p>
        <p v-else class="text-grayText text-center w-full lg:w-1/2 mb-6 md:mb-8 text-sm md:text-[16px] font-medium">
            It is important to determine the best feature list for your app. Features help you stand above your
            competition.
            The list of basic features includes:
        </p>
        <div
            class="flex-col flex w-full lg:w-5/6 ml-auto mr-auto border-t pt-20 lg:pt-[120px] lg:pb-12 lg:px-12 mt-12 mb-12 justify-around items-center border-grayBorder relative">
            <div class="flex absolute -top-6">
                <button class="w-32 text-sm" :class="{
            'btn-primary': isUsers,
            'default-awards': !isUsers,
        }" @click="showUsers">
                    FOR USERS
                </button>
                <button class="sm:w-64 ml-3 text-sm" :class="{
            'btn-primary': isAdministrators,
            'default-awards': !isAdministrators,
        }" @click="showAdministrators">
                    FOR APP ADMINISTRATORS
                </button>
            </div>
            <div v-show="isUsers"
                class="flex w-full p-6 sm:p-0 border border-[#EAEAEA] borderRadius sm:border-none lg:hidden items-center">
                <img v-if="page === 'ecommerce'" alt="users-logo" class="w-3/5 hidden sm:block lazyload"
                    data-src="../../../images/iphone-users.png" />
                <img v-if="page === 'food-delivery'" alt="users-logo" class="w-3/5 hidden sm:block lazyload"
                    data-src="../../../images/food-delivery-users.jpg" />
                <img v-if="page === 'elearning'" alt="users-logo" class="w-3/5 hidden sm:block lazyload"
                    data-src="../../../images/elearning-users.png" />
                <img v-if="page === 'erp-and-crm'" alt="users-logo" class="w-3/5 hidden sm:block lazyload"
                    data-src="../../../images/crm-users.png" />
                <img v-if="page === 'propTech'" alt="users-logo" class="w-3/5 hidden sm:block lazyload"
                    data-src="../../../images/propTech-users.png" />
                <div class="flex w-full sm:w-2/5 relative sm:ml-12 flex-col sm:gap-9">
                    <div class="absolute border-users left-[3px] h-[105%]"></div>
                    <div class="flex py-5 flex-row sm:py-0 sm:flex-col linear-gray-border sm:border-none">
                        <img data-src="../../../images/checkmark.svg" alt="checkmark"
                            class="sm:hidden h-5 w-5 lazyload" />
                        <p v-if="page === 'ecommerce'" class="ml-3">Registration </p>
                        <p v-if="page === 'food-delivery'" class="ml-3">Registration and profile management</p>
                        <p v-if="page === 'elearning'" class="ml-3">Personal teacher/student account </p>
                        <p v-if="page === 'erp-and-crm'" class="ml-3">Document management and storage</p>
                        <p v-if="page === 'propTech'" class="ml-3">User profile</p>
                        <svg v-if="page !== 'propTech'" xmlns="http://www.w3.org/2000/svg" width="204" height="9"
                            viewBox="0 0 232 9" fill="none" class="rotate-horizontally z-10 hidden sm:block">
                            <path d="M227.117 4.88599H192.029L0.5 4.88599" stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.89873" r="3.39873" transform="matrix(-1 0 0 1 231.5 0.5)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                        <svg v-if="page === 'propTech'" xmlns="http://www.w3.org/2000/svg" width="153" height="8"
                            viewBox="0 0 153 8" fill="none" class="z-10 hidden sm:block">
                            <path d="M4 4.05664H25.8319H153" stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.95537" r="3.39873" fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div v-if="page === 'elearning'"
                        class="flex py-5 flex-row sm:py-0 sm:flex-col linear-gray-border sm:border-none">
                        <img data-src="../../../images/checkmark.svg" alt="checkmark"
                            class="sm:hidden h-5 w-5 lazyload" />
                        <p class="ml-3">Notifications and reminders </p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="204" height="9" viewBox="0 0 232 9" fill="none"
                            class="rotate-horizontally z-10 hidden sm:block">
                            <path d="M227.117 4.88599H192.029L0.5 4.88599" stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.89873" r="3.39873" transform="matrix(-1 0 0 1 231.5 0.5)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div class="flex py-5 flex-row sm:py-0 sm:flex-col linear-gray-border sm:border-none">
                        <img data-src="../../../images/checkmark.svg" alt="checkmark"
                            class="sm:hidden h-5 w-5 lazyload" />
                        <p v-if="page === 'ecommerce'" class="ml-3">User profile management </p>
                        <p v-if="page === 'food-delivery'" class="ml-3">Restaurant listings </p>
                        <p v-if="page === 'elearning'" class="ml-3">Course search and filtering</p>
                        <p v-if="page === 'erp-and-crm'" class="ml-3">Financial management, accounting, and forecasting
                        </p>
                        <p v-if="page === 'propTech'" class="ml-3">Property search based on criteria <br /> like
                            location,
                            price, and
                            size</p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="198" height="9" viewBox="0 0 232 9" fill="none"
                            class="rotate-horizontally z-10 hidden sm:block">
                            <path d="M227.117 4.88599H192.029L0.5 4.88599" stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.89873" r="3.39873" transform="matrix(-1 0 0 1 231.5 0.5)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div class="flex py-5 flex-row sm:py-0 sm:flex-col linear-gray-border sm:border-none">
                        <img data-src="../../../images/checkmark.svg" alt="checkmark"
                            class="sm:hidden h-5 w-5 lazyload" />
                        <p v-if="page === 'ecommerce'" class="ml-3">Search</p>
                        <p v-if="page === 'food-delivery'" class="ml-3">Menu and dish details </p>
                        <p v-if="page === 'elearning'" class="ml-3">Enrollment and progress tracking</p>
                        <p v-if="page === 'erp-and-crm'" class="ml-3">Inventory management and stock control</p>
                        <p v-if="page === 'propTech'" class="ml-3">Listings with descriptions, <br /> photos,
                            videos, and
                            virtual tours
                        </p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="198" height="9" viewBox="0 0 232 9" fill="none"
                            class="rotate-horizontally z-10 hidden sm:block">
                            <path d="M227.117 4.88599H192.029L0.5 4.88599" stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.89873" r="3.39873" transform="matrix(-1 0 0 1 231.5 0.5)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div class="flex py-5 flex-row sm:py-0 sm:flex-col linear-gray-border sm:border-none">
                        <img data-src="../../../images/checkmark.svg" alt="checkmark"
                            class="sm:hidden h-5 w-5 lazyload" />
                        <p v-if="page === 'ecommerce'" class="ml-3">Select, preview, confirm</p>
                        <p v-if="page === 'food-delivery'" class="ml-3">Search and filtering by cuisine, restaurant, or
                            price
                            range </p>
                        <p v-if="page === 'elearning'" class="ml-3">Calendar and scheduling</p>
                        <p v-if="page === 'erp-and-crm'" class="ml-3">Supply chain management <br /> and order
                            processing
                        </p>
                        <p v-if="page === 'propTech'" class="ml-3">Advanced search filtering
                        </p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="198" height="9" viewBox="0 0 232 9" fill="none"
                            class="rotate-horizontally z-10 hidden sm:block">
                            <path d="M227.117 4.88599H192.029L0.5 4.88599" stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.89873" r="3.39873" transform="matrix(-1 0 0 1 231.5 0.5)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div class="flex py-5 flex-row sm:py-0 sm:flex-col linear-gray-border sm:border-none">
                        <img data-src="../../../images/checkmark.svg" alt="checkmark"
                            class="sm:hidden h-5 w-5 lazyload" />
                        <p v-if="page === 'ecommerce'" class="ml-3">Chat</p>
                        <p v-if="page === 'food-delivery'" class="ml-3">Contactless ordering</p>
                        <p v-if="page === 'elearning'" class="ml-3">Gamification (awards and badges)</p>
                        <p v-if="page === 'erp-and-crm'" class="ml-3">Manufacturing management and quality
                            control</p>
                        <p v-if="page === 'propTech'" class="ml-3">Ratings and reviews to leave and view
                            feedback
                        </p>
                        <svg v-if="page !== 'ecommerce'" xmlns="http://www.w3.org/2000/svg" width="153" height="8"
                            viewBox="0 0 153 8" fill="none" class="z-10 hidden sm:block">
                            <path d="M4 4.05664H25.8319H153" stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.95537" r="3.39873" fill="white" stroke="#CBD1D9" />
                        </svg>
                        <svg v-if="page === 'ecommerce'" xmlns="http://www.w3.org/2000/svg" width="198" height="9"
                            viewBox="0 0 232 9" fill="none" class="rotate-horizontally z-10 hidden sm:block">
                            <path d="M227.117 4.88599H192.029L0.5 4.88599" stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.89873" r="3.39873" transform="matrix(-1 0 0 1 231.5 0.5)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div v-if="page !== 'propTech'"
                        class="flex py-5 flex-row sm:py-0 sm:flex-col linear-gray-border sm:border-none">
                        <img data-src="../../../images/checkmark.svg" alt="checkmark"
                            class="sm:hidden h-5 w-5 lazyload" />
                        <p v-if="page === 'ecommerce'" class="ml-3">Video/audio calls</p>
                        <p v-if="page === 'food-delivery'" class="ml-3">Payment</p>
                        <p v-if="page === 'elearning'" class="ml-3">Course/lecture creation and
                            management</p>
                        <p v-if="page === 'erp-and-crm'" class="ml-3">Project management and resource
                            allocation</p>
                        <svg v-if="page === 'food-delivery'" xmlns="http://www.w3.org/2000/svg" width="110" height="8"
                            viewBox="0 0 111 8" fill="none" class="z-10 hidden sm:block">
                            <path d="M4.88281 4.38599H39.9714L110.5 4.38603" stroke="#CBD1D9" />
                            <circle cx="4.39873" cy="3.89873" r="3.39873" fill="white" stroke="#CBD1D9" />
                        </svg>
                        <svg v-if="page !== 'food-delivery'" xmlns="http://www.w3.org/2000/svg" width="225" height="9"
                            viewBox="0 0 232 9" fill="none" class="rotate-horizontally z-10 hidden sm:block">
                            <path d="M227.117 4.88599H192.029L0.5 4.88599" stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.89873" r="3.39873" transform="matrix(-1 0 0 1 231.5 0.5)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div class="flex py-5 flex-row sm:py-0 sm:flex-col linear-gray-border sm:border-none">
                        <img data-src="../../../images/checkmark.svg" alt="checkmark"
                            class="sm:hidden h-5 w-5 lazyload" />
                        <p v-if="page === 'ecommerce'" class="ml-3">Calendar and appointments</p>
                        <p v-if="page === 'food-delivery'" class="ml-3">
                            Real-time order tracking
                        </p>
                        <p v-if="page === 'elearning'" class="ml-3">
                            Lesson notes & assignment submission
                        </p>
                        <p v-if="page === 'erp-and-crm'" class="ml-3">Human resource management</p>
                        <p v-if="page === 'propTech'" class="ml-3">Saved filter configurations
                        </p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="198" height="9" viewBox="0 0 232 9" fill="none"
                            class="rotate-horizontally z-10 hidden sm:block">
                            <path d="M227.117 4.88599H192.029L0.5 4.88599" stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.89873" r="3.39873" transform="matrix(-1 0 0 1 231.5 0.5)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div class="flex py-5 flex-row sm:py-0 sm:flex-col linear-gray-border sm:border-none">
                        <img data-src="../../../images/checkmark.svg" alt="checkmark"
                            class="sm:hidden h-5 w-5 lazyload" />
                        <p v-if="page === 'ecommerce'" class="ml-3">File sharing
                        </p>
                        <p v-if="page === 'food-delivery'" class="ml-3">
                            Order history
                        </p>
                        <p v-if="page === 'elearning'" class="ml-3">
                            Virtual classrooms and videoconferencing
                        </p>
                        <p v-if="page === 'propTech'" class="ml-3">Notifications when listings match saved filter
                            configurations
                        </p>
                        <p v-if="page === 'erp-and-crm'" class="ml-3">Reporting and analytics</p>
                        <svg v-if="page === 'food-delivery'" xmlns="http://www.w3.org/2000/svg" width="110" height="8"
                            viewBox="0 0 111 8" fill="none" class="z-10 hidden sm:block">
                            <path d="M4.88281 4.38599H39.9714L110.5 4.38603" stroke="#CBD1D9" />
                            <circle cx="4.39873" cy="3.89873" r="3.39873" fill="white" stroke="#CBD1D9" />
                        </svg>
                        <svg v-if="page !== 'food-delivery'" xmlns="http://www.w3.org/2000/svg" width="198" height="9"
                            viewBox="0 0 232 9" fill="none" class="rotate-horizontally z-10 hidden sm:block">
                            <path d="M227.117 4.88599H192.029L0.5 4.88599" stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.89873" r="3.39873" transform="matrix(-1 0 0 1 231.5 0.5)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div class="flex py-5 flex-row sm:py-0 sm:flex-col linear-gray-border sm:border-none">
                        <img data-src="../../../images/checkmark.svg" alt="checkmark"
                            class="sm:hidden h-5 w-5 lazyload" />
                        <p v-if="page === 'ecommerce'" class="ml-3">Notifications and reminders
                        </p>
                        <p v-if="page === 'food-delivery'" class="ml-3">
                            Delivery and pickup options with scheduling
                        </p>
                        <p v-if="page === 'elearning'" class="ml-3">
                            Discussion forums
                        </p>
                        <p v-if="page === 'erp-and-crm'" class="ml-3">Compliance management and monitoring
                        </p>
                        <p v-if="page === 'propTech'" class="ml-3">The ability to contact agents or property owners
                        </p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="198" height="9" viewBox="0 0 232 9" fill="none"
                            class="rotate-horizontally z-10 hidden sm:block">
                            <path d="M227.117 4.88599H192.029L0.5 4.88599" stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.89873" r="3.39873" transform="matrix(-1 0 0 1 231.5 0.5)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div v-if="page === 'elearning'"
                        class="flex py-5 flex-row sm:py-0 sm:flex-col linear-gray-border sm:border-none">
                        <img data-src="../../../images/checkmark.svg" alt="checkmark"
                            class="sm:hidden h-5 w-5 lazyload" />
                        <p class="ml-3">
                            Reporting (attendance, performance, engagement) and dashboards
                        </p>
                        <svg v-if="page === 'ecommerce' || page === 'food-delivery'" xmlns="http://www.w3.org/2000/svg"
                            width="73" height="9" viewBox="0 0 73 9" fill="none" class="z-10 hidden sm:block">
                            <path d="M4 4.41406H13.5999H73" stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="4.3128" r="3.39873" fill="white" stroke="#CBD1D9" />
                        </svg>
                        <svg v-if="page === 'elearning'" xmlns="http://www.w3.org/2000/svg" width="198" height="9"
                            viewBox="0 0 232 9" fill="none" class="rotate-horizontally z-10 hidden sm:block">
                            <path d="M227.117 4.88599H192.029L0.5 4.88599" stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.89873" r="3.39873" transform="matrix(-1 0 0 1 231.5 0.5)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div class="flex py-5 flex-row sm:py-0 sm:flex-col linear-gray-border sm:border-none">
                        <img data-src="../../../images/checkmark.svg" alt="checkmark"
                            class="sm:hidden h-5 w-5 lazyload" />
                        <p v-if="page === 'ecommerce'" class="ml-3">Encounters</p>
                        <p v-if="page === 'food-delivery'" class="ml-3">
                            Promotions and discounts
                        </p>
                        <p v-if="page === 'elearning'" class="ml-3">
                            Screen sharing
                        </p>
                        <p v-if="page === 'erp-and-crm'" class="ml-3">Contact management and communication
                            history
                        </p>
                        <p v-if="page === 'propTech'" class="ml-3">Scheduling viewing appointments
                        </p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="198" height="9" viewBox="0 0 232 9" fill="none"
                            class="rotate-horizontally z-10 hidden sm:block">
                            <path d="M227.117 4.88599H192.029L0.5 4.88599" stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.89873" r="3.39873" transform="matrix(-1 0 0 1 231.5 0.5)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div class="flex py-5 flex-row sm:py-0 sm:flex-col linear-gray-border sm:border-none">
                        <img data-src="../../../images/checkmark.svg" alt="checkmark"
                            class="sm:hidden h-5 w-5 lazyload" />
                        <p v-if="page === 'ecommerce'" class="ml-3">Payment integration and/or insurance details</p>
                        <p v-if="page === 'food-delivery'" class="ml-3">
                            Notifications for order confirmation, <br /> status updates, and promos
                        </p>
                        <p v-if="page === 'elearning'" class="ml-3">
                            Raise hand button </p>
                        <p v-if="page === 'erp-and-crm'" class="ml-3">Customer feedback management and
                            support
                        </p>
                        <p v-if="page === 'propTech'" class="ml-3">Property sharing with social media integration
                        </p>
                        <svg v-if="page === 'elearning'" xmlns="http://www.w3.org/2000/svg" width="110" height="8"
                            viewBox="0 0 111 8" fill="none" class="z-10 hidden sm:block">
                            <path d="M4.88281 4.38599H39.9714L110.5 4.38603" stroke="#CBD1D9" />
                            <circle cx="4.39873" cy="3.89873" r="3.39873" fill="white" stroke="#CBD1D9" />
                        </svg>
                        <svg v-if="page !== 'elearning'" xmlns="http://www.w3.org/2000/svg" width="198" height="9"
                            viewBox="0 0 232 9" fill="none" class="rotate-horizontally z-10 hidden sm:block">
                            <path d="M227.117 4.88599H192.029L0.5 4.88599" stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.89873" r="3.39873" transform="matrix(-1 0 0 1 231.5 0.5)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div v-if="page === 'ecommerce'"
                        class="flex py-5 flex-row sm:py-0 sm:flex-col linear-gray-border sm:border-none">
                        <img data-src="../../../images/checkmark.svg" alt="checkmark"
                            class="sm:hidden h-5 w-5 lazyload" />
                        <p class="ml-3">
                            History
                        </p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="110" height="8" viewBox="0 0 111 8" fill="none"
                            class="z-10 hidden sm:block">
                            <path d="M4.88281 4.38599H39.9714L110.5 4.38603" stroke="#CBD1D9" />
                            <circle cx="4.39873" cy="3.89873" r="3.39873" fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div v-if="page === 'ecommerce'"
                        class="flex py-5 flex-row sm:py-0 sm:flex-col linear-gray-border sm:border-none">
                        <img data-src="../../../images/checkmark.svg" alt="checkmark"
                            class="sm:hidden h-5 w-5 lazyload" />
                        <p class="ml-3">
                            FAQs
                        </p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="110" height="8" viewBox="0 0 111 8" fill="none"
                            class="z-10 hidden sm:block">
                            <path d="M4.88281 4.38599H39.9714L110.5 4.38603" stroke="#CBD1D9" />
                            <circle cx="4.39873" cy="3.89873" r="3.39873" fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div v-if="page === 'ecommerce'"
                        class="flex py-5 flex-row sm:py-0 sm:flex-col linear-gray-border sm:border-none">
                        <img data-src="../../../images/checkmark.svg" alt="checkmark"
                            class="sm:hidden h-5 w-5 lazyload" />
                        <p class="ml-3">
                            Support chat
                        </p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="110" height="8" viewBox="0 0 111 8" fill="none"
                            class="z-10 hidden sm:block">
                            <path d="M4.88281 4.38599H39.9714L110.5 4.38603" stroke="#CBD1D9" />
                            <circle cx="4.39873" cy="3.89873" r="3.39873" fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div v-if="page === 'ecommerce'"
                        class="flex py-5 flex-row sm:py-0 sm:flex-col linear-gray-border sm:border-none">
                        <img data-src="../../../images/checkmark.svg" alt="checkmark"
                            class="sm:hidden h-5 w-5 lazyload" />
                        <p class="ml-3">
                            Collect and monitor health parameters (for tracking apps)
                        </p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="198" height="9" viewBox="0 0 232 9" fill="none"
                            class="rotate-horizontally z-10 hidden sm:block">
                            <path d="M227.117 4.88599H192.029L0.5 4.88599" stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.89873" r="3.39873" transform="matrix(-1 0 0 1 231.5 0.5)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div v-if="page === 'ecommerce'"
                        class="flex py-5 flex-row sm:py-0 sm:flex-col linear-gray-border sm:border-none">
                        <img data-src="../../../images/checkmark.svg" alt="checkmark"
                            class="sm:hidden h-5 w-5 lazyload" />
                        <p class="ml-3">
                            Level of privacy settings
                        </p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="198" height="9" viewBox="0 0 232 9" fill="none"
                            class="rotate-horizontally z-10 hidden sm:block">
                            <path d="M227.117 4.88599H192.029L0.5 4.88599" stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.89873" r="3.39873" transform="matrix(-1 0 0 1 231.5 0.5)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div v-if="page === 'food-delivery' || page === 'elearning'"
                        class="flex py-5 flex-row sm:py-0 sm:flex-col linear-gray-border sm:border-none">
                        <img data-src="../../../images/checkmark.svg" alt="checkmark"
                            class="sm:hidden h-5 w-5 lazyload" />
                        <p v-if="page === 'food-delivery'" class="ml-3">
                            Customer support
                        </p>
                        <p v-if="page === 'elearning'" class="ml-3">
                            Feedback and evaluation tools
                        </p>
                        <p v-if="page === 'erp-and-crm'" class="ml-3">Lead management and scoring
                        </p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="110" height="8" viewBox="0 0 111 8" fill="none"
                            class="z-10 hidden sm:block">
                            <path d="M4.88281 4.38599H39.9714L110.5 4.38603" stroke="#CBD1D9" />
                            <circle cx="4.39873" cy="3.89873" r="3.39873" fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div v-if="page === 'elearning' || page === 'erp-and-crm'"
                        class="flex py-5 flex-row sm:py-0 sm:flex-col linear-gray-border sm:border-none">
                        <img data-src="../../../images/checkmark.svg" alt="checkmark"
                            class="sm:hidden h-5 w-5 lazyload" />
                        <p v-if="page === 'elearning'" class="ml-3">
                            Payment
                        </p>
                        <p v-if="page === 'erp-and-crm'" class="ml-3">
                            Sales pipeline management
                        </p>
                        <svg v-if="page !== 'erp-and-crm'" xmlns="http://www.w3.org/2000/svg" width="110" height="8"
                            viewBox="0 0 111 8" fill="none" class="z-10 hidden sm:block">
                            <path d="M4.88281 4.38599H39.9714L110.5 4.38603" stroke="#CBD1D9" />
                            <circle cx="4.39873" cy="3.89873" r="3.39873" fill="white" stroke="#CBD1D9" />
                        </svg>
                        <svg v-if="page === 'erp-and-crm'" xmlns="http://www.w3.org/2000/svg" width="198" height="9"
                            viewBox="0 0 232 9" fill="none" class="rotate-horizontally z-10 hidden sm:block">
                            <path d="M227.117 4.88599H192.029L0.5 4.88599" stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.89873" r="3.39873" transform="matrix(-1 0 0 1 231.5 0.5)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                </div>
            </div>
            <div class="flex w-full p-6 sm:p-0 border border-[#EAEAEA] borderRadius sm:border-none lg:hidden items-center"
                v-show="isAdministrators">
                <img v-if="page === 'ecommerce'" alt="users-logo" class="w-3/5 hidden sm:block lazyload"
                    data-src="../../../images/iphone-administrators.png" />
                <img v-if="page === 'food-delivery'" alt="users-logo" class="w-3/5 hidden sm:block lazyload"
                    data-src="../../../images/food-delivery-admin.png" />
                <img v-if="page === 'elearning'" alt="users-logo" class="w-3/5 hidden sm:block lazyload"
                    data-src="../../../images/elearning-admin.png" />
                <img v-if="page === 'erp-and-crm'" alt="users-logo" class="w-3/5 hidden sm:block lazyload"
                    data-src="../../../images/crm-admin.png" />
                <img v-if="page === 'propTech'" alt="users-logo" class="w-3/5 hidden sm:block lazyload"
                    data-src="../../../images/propTech-admin.png" />
                <div class="flex w-full sm:w-2/5 relative justify-center sm:ml-12 flex-col sm:gap-8">
                    <div class="absolute border-users left-[3px] h-[703px]"></div>
                    <div v-if="page === 'ecommerce'"
                        class="flex py-5 flex-row sm:py-0 sm:flex-col linear-gray-border sm:border-none">
                        <img data-src="../../../images/checkmark.svg" alt="checkmark"
                            class="sm:hidden h-5 w-5 lazyload" />
                        <p class="ml-3">Dashboard with real-time sales, revenue, and traffic
                            data</p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="106" height="8" viewBox="0 0 111 8" fill="none"
                            class="z-10 hidden sm:block">
                            <path d="M4.88281 4.38599H39.9714L110.5 4.38603" stroke="#CBD1D9" />
                            <circle cx="4.39873" cy="3.89873" r="3.39873" fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div class="flex py-5 flex-row sm:py-0 sm:flex-col linear-gray-border sm:border-none">
                        <img data-src="../../../images/checkmark.svg" alt="checkmark"
                            class="sm:hidden h-5 w-5 lazyload" />
                        <p v-if="page === 'ecommerce'" class="ml-3">Product management (adding, editing, and removing
                            items)
                        </p>
                        <p v-if="page === 'food-delivery'" class="ml-3">Driver and courier management </p>
                        <p v-if="page === 'elearning'" class="ml-3">Management of user roles and permissions </p>
                        <p v-if="page === 'erp-and-crm'" class="ml-3">User access controls (roles and permissions)</p>
                        <p v-if="page === 'propTech'" class="ml-3">User management to manage accounts, permissions, and
                            roles
                        </p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="198" height="9" viewBox="0 0 232 9" fill="none"
                            class="rotate-horizontally z-10 hidden sm:block">
                            <path d="M227.117 4.88599H192.029L0.5 4.88599" stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.89873" r="3.39873" transform="matrix(-1 0 0 1 231.5 0.5)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div class="flex py-5 flex-row sm:py-0 sm:flex-col linear-gray-border sm:border-none">
                        <img data-src="../../../images/checkmark.svg" alt="checkmark"
                            class="sm:hidden h-5 w-5 lazyload" />
                        <p v-if="page === 'ecommerce'" class="ml-3">Low stock and restocking alerts</p>
                        <p v-if="page === 'food-delivery'" class="ml-3">Inventory and kitchen management </p>
                        <p v-if="page === 'elearning'" class="ml-3">Student/teacher profile management</p>
                        <p v-if="page === 'erp-and-crm'" class="ml-3">Third-party software integration management</p>
                        <p v-if="page === 'propTech'" class="ml-3">Listing management to add, edit,
                            review, approve, and
                            remove
                            property listings </p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="225" height="9" viewBox="0 0 232 9" fill="none"
                            class="rotate-horizontally z-10 hidden sm:block">
                            <path d="M227.117 4.88599H192.029L0.5 4.88599" stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.89873" r="3.39873" transform="matrix(-1 0 0 1 231.5 0.5)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div class="flex py-5 flex-row sm:py-0 sm:flex-col linear-gray-border sm:border-none">
                        <img data-src="../../../images/checkmark.svg" alt="checkmark"
                            class="sm:hidden h-5 w-5 lazyload" />
                        <p v-if="page === 'ecommerce'" class="ml-3">Order management to view, process, and track orders
                        </p>
                        <p v-if="page === 'food-delivery'" class="ml-3">User and restaurant management </p>
                        <p v-if="page === 'elearning'" class="ml-3">Course categorizing and tagging
                        </p>
                        <p v-if="page === 'erp-and-crm'" class="ml-3">System performance monitoring
                        </p>
                        <p v-if="page === 'propTech'" class="ml-3">Real estate agent management to manage
                            profiles, permissions, and roles</p>
                        <svg v-if="page === 'food-delivery'" xmlns="http://www.w3.org/2000/svg" width="110" height="8"
                            viewBox="0 0 111 8" fill="none" class="z-10 hidden sm:block">
                            <path d="M4.88281 4.38599H39.9714L110.5 4.38603" stroke="#CBD1D9" />
                            <circle cx="4.39873" cy="3.89873" r="3.39873" fill="white" stroke="#CBD1D9" />
                        </svg>
                        <svg v-if="page === 'elearning' || page === 'erp-and-crm' || page === 'ecommerce' || page === 'propTech'"
                            xmlns="http://www.w3.org/2000/svg" width="198" height="9" viewBox="0 0 232 9" fill="none"
                            class="rotate-horizontally z-10 hidden sm:block">
                            <path d="M227.117 4.88599H192.029L0.5 4.88599" stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.89873" r="3.39873" transform="matrix(-1 0 0 1 231.5 0.5)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div class="flex py-5 flex-row sm:py-0 sm:flex-col linear-gray-border sm:border-none">
                        <img data-src="../../../images/checkmark.svg" alt="checkmark"
                            class="sm:hidden h-5 w-5 lazyload" />
                        <p v-if="page === 'ecommerce'" class="ml-3">User account management</p>
                        <p v-if="page === 'food-delivery'" class="ml-3">User feedback management </p>
                        <p v-if="page === 'elearning'" class="ml-3">Enrollment management
                        </p>
                        <p v-if="page === 'erp-and-crm'" class="ml-3">System configuration
                        </p>
                        <p v-if="page === 'propTech'" class="ml-3">Content management </p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="222" height="9" viewBox="0 0 232 9" fill="none"
                            class="rotate-horizontally z-10 hidden sm:block">
                            <path d="M227.117 4.88599H192.029L0.5 4.88599" stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.89873" r="3.39873" transform="matrix(-1 0 0 1 231.5 0.5)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div v-if="page !== 'propTech' && page !== 'erp-and-crm'"
                        class="flex py-5 flex-row sm:py-0 sm:flex-col linear-gray-border sm:border-none">
                        <img data-src="../../../images/checkmark.svg" alt="checkmark"
                            class="sm:hidden h-5 w-5 lazyload" />
                        <p v-if="page === 'ecommerce'" class="ml-3">Payment and shipping configuration</p>
                        <p v-if="page === 'food-delivery'" class=" ml-3">
                            Payment management
                        </p>
                        <p v-if="page === 'elearning'" class="ml-3">
                            Schedule editing and event approval
                        </p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="225" height="9" viewBox="0 0 232 9" fill="none"
                            class="rotate-horizontally z-10 hidden sm:block">
                            <path d="M227.117 4.88599H192.029L0.5 4.88599" stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.89873" r="3.39873" transform="matrix(-1 0 0 1 231.5 0.5)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div class="flex py-5 flex-row sm:py-0 sm:flex-col linear-gray-border sm:border-none">
                        <img data-src="../../../images/checkmark.svg" alt="checkmark"
                            class="sm:hidden h-5 w-5 lazyload" />
                        <p v-if="page === 'ecommerce'" class="ml-3">Reporting and analytics </p>
                        <p v-if="page === 'food-delivery'" class="ml-3">
                            Marketing tools
                        </p>
                        <p v-if="page === 'elearning'" class="ml-3">
                            User activity tracking
                        </p>
                        <p v-if="page === 'erp-and-crm'" class="ml-3">
                            Module customization and management
                        </p>
                        <p v-if="page === 'propTech'" class="ml-3">Reporting and analytics on user activity and
                            listing performance</p>
                        <svg v-if="page === 'food-delivery' || page === 'elearning'" xmlns="http://www.w3.org/2000/svg"
                            width="97" height="8" viewBox="0 0 111 8" fill="none" class="z-10 hidden sm:block">
                            <path d="M4.88281 4.38599H39.9714L110.5 4.38603" stroke="#CBD1D9" />
                            <circle cx="4.39873" cy="3.89873" r="3.39873" fill="white" stroke="#CBD1D9" />
                        </svg>
                        <svg v-if="page === 'erp-and-crm' || page === 'propTech' || page === 'ecommerce'"
                            xmlns="http://www.w3.org/2000/svg" width="222" height="9" viewBox="0 0 232 9" fill="none"
                            class="rotate-horizontally z-10 hidden sm:block">
                            <path d="M227.117 4.88599H192.029L0.5 4.88599" stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.89873" r="3.39873" transform="matrix(-1 0 0 1 231.5 0.5)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div class="flex py-5 flex-row sm:py-0 sm:flex-col linear-gray-border sm:border-none">
                        <img data-src="../../../images/checkmark.svg" alt="checkmark"
                            class="sm:hidden h-5 w-5 lazyload" />
                        <p v-if="page === 'ecommerce'" class="ml-3">Customer support with access to customer inquiries
                        </p>
                        <p v-if="page === 'food-delivery' || page === 'elearning'" class="ml-3">
                            Analytics and reporting
                        </p>
                        <p v-if="page === 'erp-and-crm'" class="ml-3">Data back-ups and archiving
                        </p>
                        <p v-if="page === 'propTech'" class="ml-3">Payment processing
                        </p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="222" height="9" viewBox="0 0 232 9" fill="none"
                            class="rotate-horizontally z-10 hidden sm:block">
                            <path d="M227.117 4.88599H192.029L0.5 4.88599" stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.89873" r="3.39873" transform="matrix(-1 0 0 1 231.5 0.5)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                </div>
            </div>
            <div class="my-12 lg:flex hidden justify-center items-center" v-show="isUsers">
                <div class="border border-grayInContainer relative rounded-full w-[500px] h-[500px]">
                    <img v-if="page === 'ecommerce'" alt="users-logo" class="relative left-[20%] bottom-[10%] lazyload"
                        data-src="../../../images/iphone-users.png" />
                    <img v-if="page === 'food-delivery'" alt="users-logo"
                        class="relative left-[20%] bottom-[10%] lazyload"
                        data-src="../../../images/food-delivery-users.jpg" />
                    <img v-if="page === 'elearning'" alt="users-logo" class="relative left-[20%] bottom-[10%] lazyload"
                        data-src="../../../images/elearning-users.png" />
                    <img v-if="page === 'erp-and-crm'" alt="users-logo"
                        class="relative left-[20%] bottom-[10%] lazyload" data-src="../../../images/crm-users.png" />
                    <img v-if="page === 'propTech'" alt="users-logo" class="relative left-[20%] bottom-[10%] lazyload"
                        data-src="../../../images/propTech-users.png" />
                    <div :class="{
            '-left-[218px] top-[50px]': page === 'food-delivery' || page === 'erp-and-crm',
            '-left-[185px] top-[30px]': page === 'elearning',
            '-left-[120px] top-[50px]': page === 'propTech' || page === 'ecommerce',
        }" class="absolute  ">
                        <p v-if="page === 'ecommerce'">Registration</p>
                        <p v-if="page === 'food-delivery'">Registration and <br />profile management</p>
                        <p v-if="page === 'elearning'">Personal teacher/student account </p>
                        <p v-if="page === 'erp-and-crm'">Document management and <br /> storage</p>
                        <p v-if="page === 'propTech'">User profile</p>
                        <svg v-if="page !== 'propTech' && page !== 'ecommerce'" xmlns="http://www.w3.org/2000/svg"
                            width="255" height="30" viewBox="0 0 255 30" fill="none" class="z-10">
                            <path d="M250.117 26.5886L219.246 7.83238C211.89 3.36339 203.448 1 194.842 1H0"
                                stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.89873" r="3.39873" transform="matrix(-1 0 0 1 254.5 22.2026)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                        <svg v-if="page === 'propTech' || page === 'ecommerce'" xmlns="http://www.w3.org/2000/svg"
                            width="166" height="41" viewBox="0 0 166 41" fill="none">
                            <path d="M161 37L138.766 14.766C129.952 5.95176 117.997 1 105.532 1H0.5" stroke="#CBD1D9" />
                            <circle cx="4" cy="4" r="3.5" transform="matrix(-1 0 0 1 165.5 32.5)" fill="white"
                                stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div v-if="page === 'elearning'" class="absolute  -left-[215px] top-[70px]">
                        <p>Notifications and reminders</p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="255" height="30" viewBox="0 0 255 30" fill="none"
                            class="z-10">
                            <path d="M250.117 26.5886L219.246 7.83238C211.89 3.36339 203.448 1 194.842 1H0"
                                stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.89873" r="3.39873" transform="matrix(-1 0 0 1 254.5 22.2026)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div :class="{
            '-left-[245px] top-[120px]': page === 'erp-and-crm',
            '-left-[240px] top-[100px]': page === 'propTech',
            '-left-[238px] top-[120px]': page === 'elearning' || page === 'food-delivery',
            '-left-[238px] top-[100px]': page === 'ecommerce',
        }" class="absolute ">
                        <p v-if="page === 'ecommerce'">User profile management</p>
                        <p v-if="page === 'food-delivery'">Restaurant listings </p>
                        <p v-if="page === 'elearning'">Course search and filtering</p>
                        <p v-if="page === 'erp-and-crm'">Financial management, <br /> accounting, and forecasting
                        </p>
                        <p v-if="page === 'propTech'">Property search based on criteria <br /> like location,
                            price, and
                            size</p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="255" height="30" viewBox="0 0 255 30" fill="none"
                            class="z-10">
                            <path d="M250.117 26.5886L219.246 7.83238C211.89 3.36339 203.448 1 194.842 1H0"
                                stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.89873" r="3.39873" transform="matrix(-1 0 0 1 254.5 22.2026)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div :class="{
            'top-[160px] -left-[105px]': page === 'ecommerce',
            'top-[180px] -left-[225px]': page === 'food-delivery',
            'top-[180px] -left-[230px]': page === 'elearning' || page === 'erp-and-crm',
            'top-[190px] -left-[228px]': page === 'propTech',
        }" class="absolute ">
                        <p v-if="page === 'ecommerce'">Search
                        </p>
                        <p v-if="page === 'food-delivery'">Menu and dish details </p>
                        <p v-if="page === 'elearning'">Enrollment and progress <br /> tracking</p>
                        <p v-if="page === 'erp-and-crm'">Inventory management and <br /> stock control</p>
                        <p v-if="page === 'propTech'" class="relative right-6">Listings with descriptions, <br />
                            photos,
                            videos, and
                            virtual tours
                        </p>
                        <svg v-if="page !== 'ecommerce'" xmlns="http://www.w3.org/2000/svg" width="232" height="9"
                            viewBox="0 0 232 9" fill="none" class="z-10">
                            <path d="M227.117 4.88599H192.029L0.5 4.88599" stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.89873" r="3.39873" transform="matrix(-1 0 0 1 231.5 0.5)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                        <svg v-if="page === 'ecommerce'" width="113" height="18" viewBox="0 0 113 18" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path d="M108.117 14.5886L74.1831 3.3739C69.425 1.80142 64.446 1 59.4348 1H0"
                                stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.89873" r="3.39873" transform="matrix(-1 0 0 1 112.5 10.2031)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div :class="{
            'bottom-[200px] -left-[225px]': page === 'erp-and-crm',
            'bottom-[210px] -left-[228px]': page !== 'erp-and-crm',
            'bottom-[250px] -left-[228px]': page === 'ecommerce',
        }" class="absolute ">
                        <p v-if="page === 'ecommerce'" class="relative right-4">Select, preview, confirm</p>
                        <p v-if="page === 'food-delivery'">Search and filtering by cuisine, <br /> restaurant, or
                            price
                            range </p>
                        <p v-if="page === 'elearning'" class="ml-3">Calendar and scheduling</p>
                        <p v-if="page === 'erp-and-crm'" class="ml-3">Supply chain management <br /> and order
                            processing
                        </p>
                        <p v-if="page === 'propTech'" class="ml-3">Advanced search filtering
                        </p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="232" height="9" viewBox="0 0 232 9" fill="none">
                            <path d="M227.117 4.88599H192.029L0.5 4.88599" stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.89873" r="3.39873" transform="matrix(-1 0 0 1 231.5 0.5)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div :class="{
            'bottom-[130px] -left-[235px]': page === 'erp-and-crm',
            'bottom-[200px] -left-[85px]': page === 'ecommerce',
        }" class="absolute bottom-[150px] -left-[240px]">
                        <p v-if="page === 'ecommerce'" class=" absolute bottom-0">Chat</p>
                        <p v-if="page === 'food-delivery'" class=" absolute bottom-0">Contactless ordering</p>
                        <p v-if="page === 'elearning'" class="ml-3 absolute bottom-0">Gamification (awards and badges)
                        </p>
                        <p v-if="page === 'erp-and-crm'" class="absolute bottom-0">Manufacturing management and quality
                            control</p>
                        <p v-if="page === 'propTech'" class="absolute bottom-0 right-5">Ratings and reviews to leave and
                            view
                            feedback
                        </p>
                        <svg v-if="page !== 'ecommerce'" xmlns="http://www.w3.org/2000/svg" width="255" height="30"
                            viewBox="0 0 255 30" fill="none" class="rotate-vertically z-10">
                            <path d="M250.117 26.5886L219.246 7.83238C211.89 3.36339 203.448 1 194.842 1H0"
                                stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.89873" r="3.39873" transform="matrix(-1 0 0 1 254.5 22.2026)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                        <svg v-if="page === 'ecommerce'" width="90" height="9" viewBox="0 0 90 9" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path d="M85.1172 4.88672H50.0286L0 4.88672" stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.89873" r="3.39873" transform="matrix(-1 0 0 1 89.5 0.5)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div :class="{
            '-left-[130px] bottom-[90px]': page === 'food-delivery',
            '-left-[212px] bottom-[90px]': page === 'elearning',
            '-left-[170px] bottom-[140px]': page === 'ecommerce',
            '-left-[200px] bottom-[70px]': page === 'erp-and-crm',
        }" v-if="page !== 'propTech'" class="absolute ">
                        <p v-if="page === 'ecommerce'" class=" bottom-0 absolute">Video/audio calls</p>
                        <p v-if="page === 'food-delivery'" class="ml-3 bottom-0 absolute">Payment</p>
                        <p v-if="page === 'elearning'" class="ml-3 bottom-0 absolute">Course/lecture creation and
                            management</p>
                        <p v-if="page === 'erp-and-crm'" class="absolute ml-3 bottom-0">Project management and resource
                            allocation</p>

                        <svg v-if="page === 'elearning' || page === 'erp-and-crm'" xmlns="http://www.w3.org/2000/svg"
                            width="255" height="30" viewBox="0 0 255 30" fill="none" class="rotate-vertically z-10">
                            <path d="M250.117 26.5886L219.246 7.83238C211.89 3.36339 203.448 1 194.842 1H0"
                                stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.89873" r="3.39873" transform="matrix(-1 0 0 1 254.5 22.2026)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                        <svg v-if="page === 'food-delivery'" xmlns="http://www.w3.org/2000/svg" width="168" height="41"
                            viewBox="0 0 168 41" fill="none">
                            <path d="M163 4L140.766 26.234C131.952 35.0482 119.997 40 107.532 40H0.5"
                                stroke="#CBD1D9" />
                            <circle cx="163.5" cy="4.5" r="3.5" transform="rotate(180 163.5 4.5)" fill="white"
                                stroke="#CBD1D9" />
                        </svg>
                        <svg v-if="page === 'ecommerce'" width="190" height="18" viewBox="0 0 190 18" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path d="M185.117 3.91139L151.183 15.1261C146.425 16.6986 141.446 17.5 136.435 17.5H0"
                                stroke="#CBD1D9" />
                            <circle cx="185.601" cy="4.39814" r="3.39873" transform="rotate(180 185.601 4.39814)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div v-if="page === 'ecommerce'" class="absolute bottom-[90px] -left-[240px]">
                        <img data-src="../../../images/checkmark.svg" alt="checkmark"
                            class="sm:hidden h-5 w-5 lazyload" />
                        <p v-if="page === 'ecommerce'" class="ml-3 bottom-0 absolute">Calendar and appointments</p>
                        <svg width="280" height="30" viewBox="0 0 280 30" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path d="M275.117 3.91139L244.246 22.6676C236.89 27.1366 228.448 29.5 219.842 29.5H0"
                                stroke="#CBD1D9" />
                            <circle cx="275.601" cy="4.39814" r="3.39873" transform="rotate(180 275.601 4.39814)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div v-if="page === 'ecommerce'" class="absolute bottom-[40px] -left-[100px]">
                        <img data-src="../../../images/checkmark.svg" alt="checkmark"
                            class="sm:hidden h-5 w-5 lazyload" />
                        <p v-if="page === 'ecommerce'" class="ml-3 bottom-0 absolute">File sharing</p>
                        <svg width="168" height="41" viewBox="0 0 168 41" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path d="M163 4L140.766 26.234C131.952 35.0482 119.997 40 107.532 40H0.5"
                                stroke="#CBD1D9" />
                            <circle cx="163.5" cy="4.5" r="3.5" transform="rotate(180 163.5 4.5)" fill="white"
                                stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div :class="{
            '-right-[205px]': page === 'erp-and-crm',
        }" class="absolute top-20 -right-[185px]">
                        <p v-if="page === 'ecommerce'" class="absolute bottom-5 left-10">
                            Notifications and reminders
                        </p>
                        <p v-if="page === 'food-delivery'" class="absolute bottom-5 left-10">
                            Real-time order tracking
                        </p>
                        <p v-if="page === 'elearning'" class="absolute bottom-5 left-10">
                            Lesson notes & assignment submission
                        </p>
                        <p v-if="page === 'propTech'" class="absolute bottom-5 left-10">Saved filter configurations
                        </p>
                        <p v-if="page === 'erp-and-crm'" class="ml-3">Human resource management</p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="244" height="18" viewBox="0 0 244 18"
                            fill="none">
                            <path d="M4.88281 14.0886L38.8169 2.8739C43.575 1.30142 48.554 0.5 53.5652 0.5H243.5"
                                stroke="#CBD1D9" />
                            <circle cx="4.39873" cy="13.6014" r="3.39873" fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div :class="{
            'top-[110px] -right-[220px]': page === 'food-delivery',
            'top-[90px] -right-[220px]': page === 'elearning',
            'top-[120px] -right-[225px]': page === 'erp-and-crm',
            'top-[90px] -right-[230px]': page === 'propTech',
            'top-[90px] -right-[210px]': page === 'ecommerce',
        }" class="absolute">
                        <p v-if="page === 'ecommerce'" class="w-48 ml-12">
                            Encounters
                        </p>
                        <p v-if="page === 'food-delivery'" class="w-48 ml-12">
                            Order history
                        </p>
                        <p v-if="page === 'elearning'" class="w-48 ml-12">
                            Virtual classrooms and videoconferencing
                        </p>
                        <p v-if="page === 'erp-and-crm'" class="ml-12">Reporting and analytics</p>
                        <p v-if="page === 'propTech'" class="w-48 ml-12">Notifications when listings match saved filter
                            configurations
                        </p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="244" height="18" viewBox="0 0 244 18" fill="none"
                            class="z-10">
                            <path d="M4.88281 14.0886L38.8169 2.8739C43.575 1.30142 48.554 0.5 53.5652 0.5H243.5"
                                stroke="#CBD1D9" />
                            <circle cx="4.39873" cy="13.6014" r="3.39873" fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div :class="{
            'top-[130px] -right-[225px]': page === 'ecommerce',
            'top-[160px] -right-[235px]': page === 'food-delivery',
            'top-[160px] -right-[230px]': page === 'elearning',
            'top-[200px] -right-[225px]': page === 'erp-and-crm',
            'top-[180px] -right-[235px]': page === 'propTech',
        }" class="absolute">
                        <p v-if="page === 'ecommerce'" class="w-48 ml-12">
                            Payment integration and/or insurance details
                        </p>
                        <p v-if="page === 'food-delivery'" class="w-48 ml-12">
                            Delivery and pickup options with scheduling
                        </p>
                        <p v-if="page === 'elearning'" class="w-48 ml-12">
                            Discussion forums
                        </p>
                        <p v-if="page === 'erp-and-crm'" class="absolute ml-4 bottom-1">Compliance management and
                            monitoring
                        </p>
                        <p v-if="page === 'propTech'" class="w-48 ml-12">The ability to contact agents or property
                            owners
                        </p>
                        <svg xmlns="http://www.w3.org/2000/svg" class="rotate-horizontally" width="232" height="9"
                            viewBox="0 0 232 9" fill="none">
                            <path d="M227.117 4.88599H192.029L0.5 4.88599" stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.89873" r="3.39873" transform="matrix(-1 0 0 1 231.5 0.5)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div v-if="page === 'elearning'" class="absolute top-[200px] -right-[285px]">
                        <p class="w-72 relative left-5">
                            Reporting (attendance, performance, engagement) and dashboards
                        </p>
                        <svg xmlns="http://www.w3.org/2000/svg" class="rotate-horizontally" width="232" height="9"
                            viewBox="0 0 232 9" fill="none">
                            <path d="M227.117 4.88599H192.029L0.5 4.88599" stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.89873" r="3.39873" transform="matrix(-1 0 0 1 231.5 0.5)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div :class="{
            'bottom-[210px] -right-[235px]': page === 'food-delivery',
            'bottom-[200px] -right-[235px]': page === 'elearning',
            'bottom-[220px] -right-[228px]': page === 'erp-and-crm',
            'bottom-[170px] -right-[225px]': page === 'propTech',
            'bottom-[260px] -right-[235px]': page === 'ecommerce',
        }" class="absolute ">
                        <p v-if="page === 'ecommerce'" class="w-48 ml-12">
                            History
                        </p>
                        <p v-if="page === 'food-delivery'" class="w-48 ml-12">
                            Promotions and discounts
                        </p>
                        <p v-if="page === 'elearning'" class="w-48 ml-12">
                            Screen sharing
                        </p>
                        <p v-if="page === 'erp-and-crm'" class="absolute ml-4 bottom-1">Contact management and
                            communication
                            history
                        </p>
                        <p v-if="page === 'propTech'" class="w-48 ml-12">Scheduling viewing appointments
                        </p>
                        <svg v-if="page !== 'ecommerce'" xmlns="http://www.w3.org/2000/svg" class="rotate-horizontally"
                            width="232" height="9" viewBox="0 0 232 9" fill="none">
                            <path d="M227.117 4.88599H192.029L0.5 4.88599" stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.89873" r="3.39873" transform="matrix(-1 0 0 1 231.5 0.5)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                        <svg v-if="page === 'ecommerce'" width="111" height="8" viewBox="0 0 111 8" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.88281 4.38672H39.9714L110.5 4.38676" stroke="#CBD1D9" />
                            <circle cx="4.39873" cy="3.89873" r="3.39873" fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div :class="{
            'bottom-[120px] -right-[215px]': page === 'food-delivery',
            'bottom-[160px] -right-[145px]': page === 'elearning',
            'bottom-[150px] -right-[225px]': page === 'erp-and-crm',
            'bottom-[100px] -right-[195px]': page === 'propTech',
            'bottom-[200px] -right-[230px]': page === 'ecommerce',

        }" class="absolute">
                        <p v-if="page === 'ecommerce'" class="w-48 ml-12">
                            FAQs
                        </p>
                        <p v-if="page === 'food-delivery'" class="w-48 ml-12 absolute bottom-0">
                            Notifications for order confirmation, status updates, and promos
                        </p>
                        <p v-if="page === 'elearning'" class="w-48 ml-12 absolute bottom-0">
                            Raise hand button </p>
                        <p v-if="page === 'erp-and-crm'" class="absolute ml-10 bottom-0">Customer feedback management
                            and
                            support
                        </p>
                        <p v-if="page === 'propTech'" class="w-48 ml-12">Property sharing with social media integration
                        </p>
                        <svg v-if="page === 'elearning'" xmlns="http://www.w3.org/2000/svg" width="159" height="18"
                            viewBox="0 0 159 18" fill="none" class="z-10">
                            <path d="M4.88281 3.41139L38.8169 14.6261C43.575 16.1986 48.554 17 53.5652 17H158.5"
                                stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.89873" r="3.39873" transform="matrix(1 0 0 -1 0.5 7.79736)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                        <svg v-if="page === 'food-delivery' || page === 'erp-and-crm' || page === 'propTech'"
                            class="rotate-vertically" xmlns="http://www.w3.org/2000/svg" width="244" height="18"
                            viewBox="0 0 244 18" fill="none">
                            <path d="M4.88281 14.0886L38.8169 2.8739C43.575 1.30142 48.554 0.5 53.5652 0.5H243.5"
                                stroke="#CBD1D9" />
                            <circle cx="4.39873" cy="13.6014" r="3.39873" fill="white" stroke="#CBD1D9" />
                        </svg>
                        <svg v-if="page === 'ecommerce'" width="105" height="8" viewBox="0 0 105 8" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.88281 4.38672H39.9714L105 4.38672" stroke="#CBD1D9" />
                            <circle cx="4.39873" cy="3.89873" r="3.39873" fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div :class="{
            'bottom-[60px] -right-[165px]': page === 'food-delivery',
            'bottom-[90px] -right-[190px]': page === 'elearning',
            'bottom-[140px] -right-[220px]': page === 'ecommerce',
        }" v-if="page === 'food-delivery' || page === 'ecommerce' || page === 'elearning'" class="absolute ">
                        <p v-if="page === 'food-delivery'" class="w-48 ml-12 relative -bottom-3">
                            Customer support
                        </p>
                        <p v-if="page === 'ecommerce'" class="w-48 ml-12 relative -bottom-3">Support chat</p>
                        <p v-if="page === 'elearning'" class="w-48 ml-12 relative -bottom-3">
                            Feedback and evaluation tools
                        </p>
                        <p v-if="page === 'erp-and-crm'" class="absolute ml-12 bottom-0">Lead management and scoring
                        </p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="159" height="18" viewBox="0 0 159 18" fill="none"
                            class="z-10">
                            <path d="M4.88281 3.41139L38.8169 14.6261C43.575 16.1986 48.554 17 53.5652 17H158.5"
                                stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.89873" r="3.39873" transform="matrix(1 0 0 -1 0.5 7.79736)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div :class="{
            'bottom-[80px] -right-[185px]': page === 'erp-and-crm',
            'bottom-[40px] -right-[145px]': page === 'elearning',
            'bottom-[70px] -right-[240px]': page === 'ecommerce',
        }" v-if="page === 'elearning' || page === 'ecommerce' || page === 'erp-and-crm'" class="absolute">
                        <p v-if="page === 'elearning'" class="w-48 ml-12 relative -bottom-3">
                            Payment
                        </p>
                        <p v-if="page === 'ecommerce'" class="w-60 ml-12 relative -bottom-6">Collect and monitor health
                            parameters (for tracking
                            apps)</p>
                        <p v-if="page === 'erp-and-crm'" class="w-48 ml-12 relative -bottom-3">
                            Sales pipeline management
                        </p>
                        <svg v-if="page !== 'ecommerce'" xmlns="http://www.w3.org/2000/svg" width="159" height="18"
                            viewBox="0 0 159 18" fill="none">
                            <path d="M4.88281 3.41139L38.8169 14.6261C43.575 16.1986 48.554 17 53.5652 17H158.5"
                                stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.89873" r="3.39873" transform="matrix(1 0 0 -1 0.5 7.79736)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                        <svg v-if="page === 'ecommerce'" width="296" height="30" viewBox="0 0 296 30" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.88281 3.41139L35.7543 22.1676C43.11 26.6366 51.5516 29 60.1585 29H296"
                                stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.89873" r="3.39873" transform="matrix(1 0 0 -1 0.5 7.79688)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div v-if="page === 'ecommerce'" class="absolute bottom-5 -right-[180px]">
                        <p class="w-48 ml-12 relative -bottom-8">
                            Level of privacy settings
                        </p>
                        <svg width="273" height="40" viewBox="0 0 273 40" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path d="M5 3.5L27.234 25.734C36.0482 34.5482 48.0029 39.5 60.468 39.5H273"
                                stroke="#CBD1D9" />
                            <circle cx="4" cy="4" r="3.5" transform="matrix(1 0 0 -1 0.5 8)" fill="white"
                                stroke="#CBD1D9" />
                        </svg>
                    </div>
                </div>
            </div>
            <div class="my-12 lg:flex hidden justify-center items-center" v-show="isAdministrators">
                <div class="border border-grayInContainer relative rounded-full w-[500px] h-[500px]">
                    <img v-if="page === 'ecommerce'" alt="users-logo" class="relative left-[20%] bottom-[10%] lazyload"
                        data-src="../../../images/iphone-administrators.png" />
                    <img v-if="page === 'food-delivery'" alt="users-logo"
                        class="relative left-[20%] bottom-[10%] lazyload"
                        data-src="../../../images/food-delivery-admin.png" />
                    <img v-if="page === 'elearning'" alt="users-logo" class="relative left-[20%] bottom-[10%] lazyload"
                        data-src="../../../images/elearning-admin.png" />
                    <img v-if="page === 'erp-and-crm'" alt="users-logo"
                        class="relative left-[20%] bottom-[10%] lazyload" data-src="../../../images/crm-admin.png" />
                    <img v-if="page === 'propTech'" alt="users-logo" class="relative left-[20%] bottom-[10%] lazyload"
                        data-src="../../../images/propTech-admin.png" />
                    <div :class="{
            '-left-[222px]': page === 'food-delivery',
            '-left-[232px]': page !== 'food-delivery',
        }" class="absolute  top-[80px]">
                        <p v-if="page === 'ecommerce'">Dashboard with real-time sales, <br /> revenue, and traffic
                            data</p>
                        <p v-if="page === 'food-delivery'">Driver and courier management </p>
                        <p v-if="page === 'elearning'">Management of user roles and <br /> permissions </p>
                        <p v-if="page === 'erp-and-crm'">User access controls (roles <br /> and permissions)</p>
                        <p v-if="page === 'propTech'">User management to manage <br /> accounts, permissions, and
                            roles
                        </p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="255" height="30" viewBox="0 0 255 30" fill="none"
                            class="z-10">
                            <path d="M250.117 26.5886L219.246 7.83238C211.89 3.36339 203.448 1 194.842 1H0"
                                stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.89873" r="3.39873" transform="matrix(-1 0 0 1 254.5 22.2026)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div v-if="page === 'ecommerce'" class="absolute -left-[225px] top-[160px]">
                        <p>Product management (adding, <br /> editing, and removing
                            items)
                        </p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="232" height="9" viewBox="0 0 232 9" fill="none"
                            class="z-10">
                            <path d="M227.117 4.88599H192.029L0.5 4.88599" stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.89873" r="3.39873" transform="matrix(-1 0 0 1 231.5 0.5)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div :class="{
            'bottom-[230px]': page === 'ecommerce',
            'bottom-[270px]': page === 'food-delivery' || page === 'elearning' || page === 'erp-and-crm' || page === 'propTech',
        }" class="absolute  -left-[228px]">
                        <p v-if="page === 'ecommerce'" class="relative right-4">Low stock and restocking alerts</p>
                        <p v-if="page === 'food-delivery'" class=" ml-3">Inventory and kitchen <br /> management </p>
                        <p v-if="page === 'elearning'">Student/teacher profile <br /> management</p>
                        <p v-if="page === 'erp-and-crm'" class="relative right-4">Third-party software integration
                            <br />
                            management
                        </p>
                        <p v-if="page === 'propTech'" class="relative right-3">Listing management to add, edit, <br />
                            review, approve, and
                            remove <br />
                            property listings </p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="232" height="9" viewBox="0 0 232 9" fill="none">
                            <path d="M227.117 4.88599H192.029L0.5 4.88599" stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.89873" r="3.39873" transform="matrix(-1 0 0 1 231.5 0.5)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div :class="{
            'bottom-[180px] -left-[250px]': page === 'erp-and-crm' || page === 'propTech',
        }" class="absolute bottom-[150px] -left-[240px]">
                        <p v-if="page === 'ecommerce'" class=" absolute bottom-0">Order management to view, process, and
                            track orders</p>
                        <p v-if="page === 'food-delivery'" class="absolute bottom-0 ml-3">User and restaurant <br />
                            management
                        </p>
                        <p v-if="page === 'elearning'" class="absolute bottom-0 ml-3">Course categorizing and tagging
                        </p>
                        <p v-if="page === 'erp-and-crm'" class="absolute bottom-0 ml-3">System performance monitoring
                        </p>
                        <p v-if="page === 'propTech'" class="absolute bottom-0 right-2">Real estate agent management to
                            manage
                            profiles, permissions, and roles</p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="255" height="30" viewBox="0 0 255 30" fill="none"
                            class="rotate-vertically z-10">
                            <path d="M250.117 26.5886L219.246 7.83238C211.89 3.36339 203.448 1 194.842 1H0"
                                stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.89873" r="3.39873" transform="matrix(-1 0 0 1 254.5 22.2026)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div :class="{
            'top-[140px] -right-[220px]': page === 'erp-and-crm' || page === 'propTech',
            'top-20 -right-[185px]': page !== 'erp-and-crm' && page !== 'propTech' && page !== 'ecommerce',
            'top-32 -right-[215px]': page === 'ecommerce',

        }" class="absolute">
                        <p v-if="page === 'ecommerce'" class="absolute bottom-5 left-10">
                            User account management
                        </p>
                        <p v-if="page === 'food-delivery'" class="absolute bottom-5 ml-3 left-10">User feedback
                            management
                        </p>
                        <p v-if="page === 'elearning'" class="absolute bottom-5 ml-3 left-10">Enrollment management
                        </p>
                        <p v-if="page === 'erp-and-crm'" class="absolute bottom-5 ml-3 left-10">System configuration
                        </p>
                        <p v-if="page === 'propTech'" class="absolute bottom-5 ml-3 left-10">Content management </p>

                        <svg xmlns="http://www.w3.org/2000/svg" width="244" height="18" viewBox="0 0 244 18"
                            fill="none">
                            <path d="M4.88281 14.0886L38.8169 2.8739C43.575 1.30142 48.554 0.5 53.5652 0.5H243.5"
                                stroke="#CBD1D9" />
                            <circle cx="4.39873" cy="13.6014" r="3.39873" fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div v-if="page !== 'erp-and-crm' && page !== 'propTech'" :class="{
            'top-[140px] -right-[235px]': page === 'ecommerce',
            'top-[100px] -right-[225px]': page === 'elearning',
            'top-[110px] -right-[220px]': page === 'food-delivery',
        }" class="absolute">
                        <p v-if="page === 'ecommerce'" class="w-48 ml-12">
                            Payment and shipping configuration
                        </p>
                        <p v-if="page === 'food-delivery'" class="w-48 ml-12">
                            Payment management
                        </p>
                        <p v-if="page === 'elearning'" class="w-48 ml-12">
                            Schedule editing and event approval
                        </p>

                        <svg xmlns="http://www.w3.org/2000/svg" width="244" height="18" viewBox="0 0 244 18" fill="none"
                            class="z-10">
                            <path d="M4.88281 14.0886L38.8169 2.8739C43.575 1.30142 48.554 0.5 53.5652 0.5H243.5"
                                stroke="#CBD1D9" />
                            <circle cx="4.39873" cy="13.6014" r="3.39873" fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div :class="{
            'top-[190px]': page === 'food-delivery' || page === 'elearning',
            'top-[210px]': page === 'ecommerce'
        }" class="absolute top-[170px]  -right-[235px]">
                        <p v-if="page === 'ecommerce'" class="w-48 ml-12">
                            Reporting and analytics
                        </p>
                        <p v-if="page === 'food-delivery'" class="w-48 ml-12">
                            Marketing tools
                        </p>
                        <p v-if="page === 'elearning'" class="w-48 ml-12">
                            User activity tracking
                        </p>
                        <p v-if="page === 'erp-and-crm'" class="w-48 ml-12">
                            Module customization and management
                        </p>
                        <p v-if="page === 'propTech'" class="w-48 ml-12">Reporting and analytics on user activity and
                            listing performance</p>

                        <svg xmlns="http://www.w3.org/2000/svg" class="rotate-horizontally" width="232" height="9"
                            viewBox="0 0 232 9" fill="none">
                            <path d="M227.117 4.88599H192.029L0.5 4.88599" stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.89873" r="3.39873" transform="matrix(-1 0 0 1 231.5 0.5)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div :class="{
            'bottom-[170px] -right-[225px]': page === 'ecommerce',
            'bottom-[190px] -right-[230px]': page !== 'ecommerce'
        }" v-if="page !== 'erp-and-crm' && page !== 'propTech'" class="absolute">
                        <p v-if="page === 'ecommerce'" class="w-48 ml-12">
                            Customer support with access to customer inquiries
                        </p>
                        <p v-if="page === 'food-delivery' || page === 'elearning'" class="w-48 ml-12">
                            Analytics and reporting
                        </p>
                        <svg xmlns="http://www.w3.org/2000/svg" class="rotate-horizontally" width="232" height="9"
                            viewBox="0 0 232 9" fill="none">
                            <path d="M227.117 4.88599H192.029L0.5 4.88599" stroke="#CBD1D9" />
                            <circle cx="3.89873" cy="3.89873" r="3.39873" transform="matrix(-1 0 0 1 231.5 0.5)"
                                fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                    <div v-if="page === 'erp-and-crm' || page === 'propTech'"
                        class="absolute bottom-[180px] -right-[235px]">
                        <p v-if="page === 'erp-and-crm'" class="absolute ml-10 bottom-0">Data back-ups and archiving
                        </p>
                        <p v-if="page === 'propTech'" class="absolute ml-10 bottom-0">Payment processing
                        </p>
                        <svg class="rotate-vertically" xmlns="http://www.w3.org/2000/svg" width="244" height="18"
                            viewBox="0 0 244 18" fill="none">
                            <path d="M4.88281 14.0886L38.8169 2.8739C43.575 1.30142 48.554 0.5 53.5652 0.5H243.5"
                                stroke="#CBD1D9" />
                            <circle cx="4.39873" cy="13.6014" r="3.39873" fill="white" stroke="#CBD1D9" />
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Charts",
    props: {
        page: String,
    },
    data() {
        return {
            isUsers: true,
            isAdministrators: false,
        };
    },
    methods: {
        showUsers() {
            this.isUsers = true;
            this.isAdministrators = false;
        },
        showAdministrators() {
            this.isUsers = false;
            this.isAdministrators = true;
        },
    },
};
</script>
